import Chartkick from "chartkick"
import Highcharts from "highcharts"

Chartkick.use(Highcharts)
